module.exports = __webpack_public_path__ + "img/benefits.eba0def6.jpg";